export default {
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean,
	disabled:Boolean,
  },

  data() {
  	return {
  		useContextualTextClasses: false,
  	}
  },

  computed: {
  	$contextualClasses() {
  		const suffix = this.useContextualTextClasses ? '--text' : ''
  		return {
	  		[`primary${suffix}`]: this.primary,
	  		[`secondary${suffix}`]: this.secondary,
	  		[`success${suffix}`]: this.success,
	  		[`info${suffix}`]: this.info,
	  		[`disabled${suffix}`]: this.disabled,
	  		[`warning${suffix}`]: this.warning,
	  		[`error${suffix}`]: this.error,
	  		'black--text': !this.useContextualTextClasses && (this.secondary || this.success || this.warning),
	  		'white--text': !this.useContextualTextClasses && (this.primary || this.info || this.error),
	  	}
  	}
  }
}
